(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auraminot-pockets"] && !Shopify.designMode) return;
  try {
    
(() => {
  function loadPockets(section) {
    import(section.dataset.module).catch(error => {
      section.classList.add('scene-unavailable');
      console.error('Pocket animation unavailable:', error);
    });
  }

  const pocketsLoader = new IntersectionObserver((entries, observer) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      loadPockets(entry.target);
    }
  }, { rootMargin: '300px' });

  function observePockets(container) {
    container.querySelectorAll('auraminot-pockets').forEach(section => {
      if (section.hasAttribute('data-eager-model')) loadPockets(section);
      else pocketsLoader.observe(section);
    });
  }

  observePockets(document);
  document.addEventListener('shopify:section:load', event => observePockets(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('auraminot-pockets').forEach(section => pocketsLoader.unobserve(section));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
